var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ListItem } from "@mui/material";
import { getOptionStyles } from "../../helpers";
import Text from "../../../../Text";
export default function TextOption(_a) {
    var renderProps = _a.renderProps, option = _a.option, _b = _a.size, size = _b === void 0 ? "medium" : _b;
    var style = useMemo(function () { return getOptionStyles(size); }, [size]);
    return (_jsx(ListItem, __assign({}, renderProps, { sx: style, "data-testid": "option-".concat(option.id, "-y") }, { children: _jsx(Text, __assign({ variant: size === "medium" ? "body1" : "body2" }, { children: option.name })) })));
}
